import { useState, useEffect } from 'react';

interface TextStyle {
    fontSize?: string | number;
    fontFamily?: string;
    fontWeight?: string | number;
    fontStyle?: string;
    paddingLeft?: number;
    paddingRight?: number;
    letterSpacing?: string | number;
    textTransform?: string;
}

function useTextWidthDOM(text: string, style: TextStyle): number {
    const [width, setWidth] = useState(0);

    useEffect(() => {
        // 创建临时 DOM 元素测量宽度
        const element = document.createElement('span');
        element.innerText = text;
        element.style.position = 'absolute';
        element.style.visibility = 'hidden';
        element.style.whiteSpace = 'nowrap';

        // 应用所有样式
        if (style.fontSize) {
            element.style.fontSize = typeof style.fontSize === 'number' ? `${style.fontSize}px` : style.fontSize;
        }
        if (style.fontFamily) {
            element.style.fontFamily = style.fontFamily;
        }
        if (style.fontWeight) {
            element.style.fontWeight = style.fontWeight.toString();
        }
        if (style.fontStyle) {
            element.style.fontStyle = style.fontStyle;
        }
        if (style.letterSpacing) {
            element.style.letterSpacing =
                typeof style.letterSpacing === 'number' ? `${style.letterSpacing}px` : style.letterSpacing;
        }
        if (style.textTransform) {
            element.style.textTransform = style.textTransform;
        }

        // 添加到 DOM 并测量
        document.body.appendChild(element);
        const elementWidth = element.getBoundingClientRect().width;

        // 加上padding
        const paddingLeft = style.paddingLeft || 0;
        const paddingRight = style.paddingRight || 0;
        const totalWidth = elementWidth + paddingLeft + paddingRight;

        setWidth(totalWidth);

        // 清理
        document.body.removeChild(element);
    }, [text, style]);

    return width;
}

export default useTextWidthDOM;
export type { TextStyle };

